import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { observer } from "mobx-react";
import { NakiNigunAlbumTrackProducerEdit } from "administration/naki-nigun/components";

const NakiNigunAlbumTrackProducerEditModalTemplate = observer(function NakiNigunAlbumTrackProducerEditModalTemplate({
    nakiNigunAlbumTrackListViewStore,
    modalParams,
    t,
}) {
    return (
        <MrbModal
            modalParams={modalParams}
            t={t}
            className="modal__content modal__content--xlrg"
            shouldCloseOnOverlayClick={false}
        >
            {() => (
                <NakiNigunAlbumTrackProducerEdit
                    nakiNigunAlbumTrackListViewStore={nakiNigunAlbumTrackListViewStore}
                    trackId={modalParams.data.trackId}
                    producers={modalParams.data.producers}
                    trackTitle={modalParams.data.trackTitle}
                    closeModal={modalParams.close}
                    t={t}
                />
            )}
        </MrbModal>
    );
});

NakiNigunAlbumTrackProducerEditModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default NakiNigunAlbumTrackProducerEditModalTemplate;
